<template lang="pug">
section
  s-page-title(title='FAQ')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
      template(slot='controls')
        v-layout
          v-flex(xs-12)
            s-region-picker(
              :value='dataFilter.region_id'
              @change='setRegion'
            )
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.question }}
          td {{ props.item.regions }}
          td {{ getIds(props.item.groups) }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item'
              @success='fetch'
              resource='seo/faqs'
            )
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: true
      },
      {
        text: 'Вопрос',
        align: 'left',
        sortable: true,
        value: 'question'
      },
      {
        text: 'Регионы',
        align: 'left',
        sortable: true,
        value: 'regions'
      },
      {
        text: 'Группы',
        align: 'left',
        sortable: true,
        value: 'groups'
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ],
    sorting: {
      opened: false,
      resource: 'seo/faqs',
      itemValue: 'id',
      itemText: 'question'
    }
  }),

  created() {
    this.fetch()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    setRegion(region_id = null) {
      this.setDataFilter({ region_id })
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Seo.Faq.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({
        config: {
          params: this.dataFilter
        }
      })
    },

    getIds(array) {
      if (!array) return ''
      return array.map((item)=> item.id).join(', ')
    },

    async onDelete({ id }) {
      if (await this.$confirm('Вы уверены?')) {
        try {
          await this.destroy({ id })
          this.fetch()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления')
        }
      }
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('seo/faq', ['fetchList', 'destroy']),
    ...mapMutations('seo/faq', ['setDataFilter'])
  },

  computed: {
    ...mapState('seo/faq', ['total', 'dataFilter']),
    ...mapGetters('seo/faq', ['list', 'isLoading']),
  }
}
</script>
